<template>
<div class="chapter">
<div class="inner_page">
<div class="sidebar1">
<p class="PT"><a id="page_1">“If You Break Your Leg, Don’t Come Running to Me!”</a></p><a id="page_1">
<p class="PST">(Spring and Summer)</p>
</a><p><a id="page_1"></a><a id="page_2"></a></p><a id="page_2">
</a></div><a id="page_2">
</a><p><a id="page_2"></a><a id="page_3"></a></p><a id="page_3">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?ab006a06